/* Circular · accessory product template
   The simple sibling of cx-ring.js. Accessories have at most one or two options and no
   add-ons, so this is a generic option->variant matcher: it reads the variant table
   Liquid prints, keeps the URL and the hidden input in sync, swaps the gallery image
   when a variant owns one, and adds a single line to the cart.

   Cart hand-off is identical to the ring page on purpose — post to /cart/add.js, then
   fire cx:added and ask CXCart to open. Never call CXCart.add(): that would add a
   second line. */
(function () {
  'use strict';

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    v = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  function init(root) {
    if (!root || root.dataset.cxaOn) return;
    root.dataset.cxaOn = '1';

    var cfgEl = root.querySelector('[data-cxa-cfg]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var form     = root.querySelector('[data-cxa-form]');
    var idInput  = root.querySelector('[data-cxa-variant-id]');
    var priceEl  = root.querySelector('[data-cxa-price]');
    var wasEl    = root.querySelector('[data-cxa-was]');
    var saveEl   = root.querySelector('[data-cxa-save]');
    var atc      = root.querySelector('[data-cxa-atc]');
    var msg      = root.querySelector('[data-cxa-msg]');
    var stage    = root.querySelector('[data-cxa-stage]');
    if (!form || !idInput || !atc) return;

    var current = null;

    function selected() {
      var vals = [];
      root.querySelectorAll('[data-cxa-opt]').forEach(function (group) {
        var i = Number(group.getAttribute('data-cxa-opt'));
        var picked = group.querySelector('input:checked, select');
        vals[i] = picked ? picked.value : null;
      });
      return vals;
    }

    function match() {
      var want = selected();
      for (var i = 0; i < cfg.variants.length; i++) {
        var v = cfg.variants[i], ok = true;
        for (var j = 0; j < want.length; j++) {
          if (want[j] == null) continue;
          if (v.options[j] !== want[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function say(text, state) {
      if (!msg) return;
      msg.textContent = text || '';
      if (state) msg.setAttribute('data-state', state); else msg.removeAttribute('data-state');
    }

    /* Grey out any option value that no available variant can produce, so a shopper
       cannot walk into a dead combination and only find out at Add to cart. */
    function markUnavailable() {
      var want = selected();
      root.querySelectorAll('[data-cxa-opt]').forEach(function (group) {
        var gi = Number(group.getAttribute('data-cxa-opt'));
        group.querySelectorAll('input[type="radio"]').forEach(function (inp) {
          var reachable = cfg.variants.some(function (v) {
            if (v.options[gi] !== inp.value) return false;
            if (!v.available) return false;
            for (var j = 0; j < want.length; j++) {
              if (j === gi || want[j] == null) continue;
              if (v.options[j] !== want[j]) return false;
            }
            return true;
          });
          var label = inp.closest('label');
          if (label) label.classList.toggle('is-out', !reachable);
        });
      });
    }

    function swapImage(v) {
      if (!stage || !v || !v.image) return;
      var img = stage.querySelector('img');
      if (!img || img.getAttribute('src') === v.image) return;
      img.setAttribute('src', v.image);
      img.setAttribute('srcset', '');
      if (v.image_alt) img.setAttribute('alt', v.image_alt);
    }

    function paint() {
      var v = match();
      markUnavailable();
      if (!v) {
        atc.disabled = true;
        atc.textContent = cfg.strings.unavailable;
        say(cfg.strings.pick, 'err');
        return;
      }
      current = v;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, cfg.moneyFormat);
      if (wasEl) {
        var show = v.compare > v.price;
        wasEl.hidden = !show;
        if (show) wasEl.textContent = money(v.compare, cfg.moneyFormat);
      }
      if (saveEl) {
        var show2 = v.compare > v.price;
        saveEl.hidden = !show2;
        /* __N__ placeholder, and floor to agree with Liquid's integer division — the same
           two faults that dropped the "%" on the ring page. */
        if (show2) saveEl.textContent = cfg.strings.save.replace('__N__', Math.floor((1 - v.price / v.compare) * 100));
      }
      swapImage(v);
      atc.disabled = !v.available;
      atc.textContent = v.available ? cfg.strings.add : cfg.strings.soldout;
      say('');

      if (cfg.variants.length > 1 && window.history && history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
    }

    root.querySelectorAll('[data-cxa-opt]').forEach(function (g) {
      g.addEventListener('change', paint);
    });

    function notifyCart() {
      try { window.postMessage({ type: 'UCART_CHANGED' }, '*'); } catch (e) {}
      document.dispatchEvent(new CustomEvent('cx:added', { bubbles: true }));
      if (window.CXCart && typeof window.CXCart.open === 'function') window.CXCart.open();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current || !current.available) return;
      atc.disabled = true;
      atc.classList.add('is-busy');
      say('');
      fetch(cfg.routes.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: Number(current.id), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) throw new Error('add failed');
          say(cfg.strings.added, 'ok');
          atc.classList.add('is-done');
          setTimeout(function () { atc.classList.remove('is-done'); }, 1600);
          notifyCart();
        })
        .catch(function () { say(cfg.strings.error, 'err'); })
        .finally(function () {
          atc.disabled = false;
          atc.classList.remove('is-busy');
        });
    });

    /* thumbnails */
    root.querySelectorAll('[data-cxa-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var img = stage && stage.querySelector('img');
        if (!img) return;
        img.setAttribute('src', t.getAttribute('data-full'));
        img.setAttribute('srcset', '');
        img.setAttribute('alt', t.getAttribute('data-alt') || '');
        root.querySelectorAll('[data-cxa-thumb]').forEach(function (o) { o.classList.toggle('is-on', o === t); });
      });
    });

    paint();
  }

  function boot() { document.querySelectorAll('[data-cx-accessory]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
